import { AbstractBuilder } from "./AbstractBuilder.js";

export { OGCGeoserver }

class OGCGeoserver extends AbstractBuilder {
    
    static getFilterParams(harmonizedFilters) {
        const filter = super.getFilterParams(harmonizedFilters);
        return (filter.length) ? { filter: `<Filter xmlns="http://www.opengis.net/ogc">${filter}</Filter>` } : {};
    }

    static bt(property, begin, end) {
        return `<And><PropertyIsGreaterThanOrEqualTo><PropertyName>${property}</PropertyName><Literal>${begin}</Literal></PropertyIsGreaterThanOrEqualTo><PropertyIsLessThanOrEqualTo><PropertyName>${property}</PropertyName><Literal>${end}</Literal></PropertyIsLessThanOrEqualTo></And>`;
    }

    static eq(property, value) {
        return `<PropertyIsEqualTo><PropertyName>${property}</PropertyName><Literal>${value}</Literal></PropertyIsEqualTo>`;
    }

    static like(property, value) {
        return `<PropertyIsLike wildCard="*" singleChar="#" escapeChar="!"><PropertyName>${property}</PropertyName><Literal>${value}</Literal></PropertyIsLike>`;
    }

    static gt(property, value) {
        return `<PropertyIsGreaterThan><PropertyName>${property}</PropertyName><Literal>${value}</Literal></PropertyIsGreaterThan>`;
    }

    static gteq(property, value) {
        return `<PropertyIsGreaterThanOrEqualTo><PropertyName>${property}</PropertyName><Literal>${value}</Literal></PropertyIsGreaterThanOrEqualTo>`;
    }

    static lt(property, value) {
        return `<PropertyIsLessThan><PropertyName>${property}</PropertyName><Literal>${value}</Literal></PropertyIsLess>`;
    }

    static lteq(property, value) {
        return `<PropertyIsLessThanOrEqualTo><PropertyName>${property}</PropertyName><Literal>${value}</Literal></PropertyIsLessThanOrEqualTo>`;
    }

    static null(property) {
        return `<PropertyIsNull><PropertyName>${property}</PropertyName></PropertyIsNull>`;
    }

    static or(filters) {
        return this.join_(filters, "Or");
    }

    static and(filters) {
        return this.join_(filters, "And");
    }

    static join_(filters, operator) {
        if (filters.length == 0) return "";
        if (filters.length == 1) return filters[0];
        const result = filters.join("");
        return `<${operator}>${result}</${operator}>`;
    }

}